<template>
    <div class="banner-content-top pt-spc5">
        <div class="section-title">
            <h1 class="title text-40 font-semibold text-white leading-48">Model X</h1>
        </div>
    </div>
</template>

<script>
    export default {
        name: "ModelXHeader"
    }
</script>

<style scoped>

</style>